import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

if (typeof structuredClone === "undefined") {
  globalThis.structuredClone = (obj: any) => JSON.parse(JSON.stringify(obj)); // Basic alternative
}
bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
